import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';

import { Level } from '..';

export const Message = ({
  level,
  notification,
}: {
  level: Level;
  notification: ReactNode;
}) => {
  if (!notification) {
    return null;
  }
  return (
    <Horizontal>
      {(level === Level.ERROR || level === Level.WARN) && (
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          size="lg"
          color={
            level === Level.ERROR ? 'var(--c-red-500)' : 'var(--c-yellow-500)'
          }
        />
      )}
      <span>{notification}</span>
    </Horizontal>
  );
};
